import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const AddIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="AddIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/add">
            <path fill="none" id="Vector" d="M5 12H19M12 5V19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
        </g>
    </SvgIcon>
)
